import { Component, Input, OnInit } from '@angular/core';
import { PathFinderService } from '../../services/path-finder.service';
import { NgbModal } from '@ng-bootstrap/ng-bootstrap';
import { EngineCheckComponent } from '../../authorization/engine-check/engine-check.component';

@Component({
  selector: 'app-video-transition',
  templateUrl: './video-transition.component.html'
})
export class VideoTransitionComponent implements OnInit {

  @Input() quoteStateId!: number;

  constructor(private pathFinder: PathFinderService, private modalService: NgbModal) {
  }
  
  ngOnInit(): void {
    this.pathFinder.registerNonAuthTransitionEvent(onComplete => {
      const storedQuoteStateId = sessionStorage.getItem('video_transition_purchase');
      const alreadyVideoed = storedQuoteStateId && storedQuoteStateId === this.quoteStateId.toString();

      const isElectricVehicle = this.pathFinder.isElectricVehicle()
      const siteVideoEnabled = this.pathFinder.getAnswerValueForStringComparison('VideoEnabledForSite', null) === 'true';
      const isBelowValuationThreshold = this.pathFinder.getValuationAmount() < this.pathFinder.getPurchaseSettingAsNumber('EngineVerificationVideoValuationAmount');
      
      if (alreadyVideoed || isElectricVehicle || !siteVideoEnabled || isBelowValuationThreshold) {
        onComplete(true);
        return;
      }

      const engineCheckModal = this.modalService.open(EngineCheckComponent, {
        keyboard: false,
        backdrop: 'static',
        centered: true,
        size: 'md',
      });
  
      engineCheckModal.componentInstance.quoteStateId = this.quoteStateId;
      engineCheckModal.componentInstance.isNew = true;
      engineCheckModal.componentInstance.isAuthTask = false;
  
      engineCheckModal.result.then(
        () => {
          sessionStorage.setItem('video_transition_purchase', this.quoteStateId.toString());
          onComplete(true);
        },
        () => { onComplete(false); }
      );
    });
  }
}
